/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './dismissMatch.defs.js'
export { main as default } from './dismissMatch.defs.js'
